var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-wrapper',{attrs:{"loading":_vm.loadingStockMovements}},[_c('div',{staticClass:"space-y-4"},[_c('div',{staticClass:"flex justify-end gap-2"},[_c('base-select',{attrs:{"shadow":false,"options":[
          {
            key: 'null',
            value: null,
            label: 'Semua',
          },
          {
            key: 'true',
            value: true,
            label: 'Terkirim',
          },
          {
            key: 'false',
            value: false,
            label: 'Belum Dikirim',
          },
        ]},on:{"change":_vm.loadStockMovements},model:{value:(_vm.filter.is_shipped),callback:function ($$v) {_vm.$set(_vm.filter, "is_shipped", $$v)},expression:"filter.is_shipped"}}),_c('base-input',{attrs:{"shadow":false,"type":"search","placeholder":"Cari kode atau nama","debounce":""},on:{"native-input":_vm.loadStockMovements},model:{value:(_vm.filter.search),callback:function ($$v) {_vm.$set(_vm.filter, "search", $$v)},expression:"filter.search"}})],1),_c('datatable',{attrs:{"columns":[
        {
          id: 'code',
          name: 'Nomor Pengemasan',
        },
        {
          id: 'office_code',
          name: 'Nomor Pengiriman',
        },
        {
          id: 'createdAt',
          name: 'Tanggal Pengemasan',
        },
        {
          id: 'items_count',
          name: 'Total Barang',
          theadClass: 'text-right',
        },
        {
          id: 'status',
          name: 'Status',
          theadClass: 'text-center',
        },
      ],"total":_vm.stockMovements.meta.page.total,"perPage":_vm.stockMovements.meta.page.perPage,"currentPage":_vm.stockMovements.meta.page.currentPage,"meta":_vm.stockMovements.meta,"cursor":""},on:{"pagechanged":_vm.onChangePage},scopedSlots:_vm._u([{key:"tbody",fn:function({ classes }){return _vm._l((_vm.stockMovements.data),function(stockMovement){return _c('tr',{key:stockMovement.id,class:[classes.tr, 'cursor-pointer bg-white hover:bg-green-100'],on:{"click":function($event){$event.preventDefault();_vm.onClickDetail(_vm.getStockMovementIncluded(stockMovement))}}},[_c('td',{class:classes.td},[_c('div',{staticClass:"font-bold text-gray-900"},[_vm._v(" "+_vm._s(_vm.getStockMovementIncluded(stockMovement).attributes.code)+" / "+_vm._s(_vm.getStockMovementIncluded(stockMovement).attributes.order_code)+" ")])]),_c('td',{class:classes.td},[_vm._v(" "+_vm._s(_vm.getStockMovementIncluded(stockMovement).attributes .reference_code ?? '-')+" ")]),_c('td',{class:classes.td},[_vm._v(" "+_vm._s(_vm._f("formatDate")(_vm.getStockMovementIncluded(stockMovement).attributes.updatedAt))+" ")]),_c('td',{class:[classes.td, 'text-right']},[_vm._v(" "+_vm._s(_vm.getStockMovementIncluded(stockMovement).attributes .product_summaries ? Object.keys( _vm.getStockMovementIncluded(stockMovement).attributes .product_summaries ).length : '-')+" ")]),_c('td',{class:[classes.td, 'text-center']},[(
                _vm.getStockMovementIncluded(stockMovement).attributes.is_shipped
              )?_c('base-badge',{attrs:{"color":"green"}},[_vm._v("Terkirim")]):_c('base-badge',{attrs:{"color":"red"}},[_vm._v("Belum Dikirim")])],1)])})}}])})],1),_c('view-stock-movement-modal',{attrs:{"stock-movement-id":_vm.detailModal.stockMovementId,"visible":_vm.detailModal.visible,"with-batch":"","columns":[],"with-actions":""},on:{"close":function($event){_vm.detailModal.visible = false},"sent":_vm.onSent}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }